import { TaxRatesService } from "@common/client"
import { makeAxiosMutation, makeQuery } from "./utils"

const TAX_RATE_PAGE_SIZE = 500

export const taxRatesBaseKey = ["tax-rates"] as const

export const taxRateKey = (taxRateId: string) =>
  [...taxRatesBaseKey, "detail", taxRateId] as const

export const taxRatesKey = (search: string, deleted: boolean) =>
  [...taxRatesBaseKey, "list", { search, deleted }] as const

export const taxRatesQuery = makeQuery({
  serviceCall: ({ search, deleted }: { search: string; deleted: boolean }) =>
    TaxRatesService.listTaxRates({
      search: search || null,
      deleted,
      limit: TAX_RATE_PAGE_SIZE,
    }),
  queryKey: ({ search, deleted }) => taxRatesKey(search, deleted),
})

export const taxRateQuery = makeQuery({
  serviceCall: (params: Parameters<typeof TaxRatesService.get>[0]) =>
    TaxRatesService.get({ ...params, include_archived: true }),
  queryKey: ({ tax_rate_id }) => taxRateKey(tax_rate_id),
})

export const useCreateTaxRateMutation = makeAxiosMutation({
  serviceCall: TaxRatesService.create,
  invalidates: () => [taxRatesBaseKey],
})

export const useUpdateTaxRateMutation = makeAxiosMutation({
  serviceCall: TaxRatesService.update,
  invalidates: () => [taxRatesBaseKey],
})

export const useDeleteTaxRateMutation = makeAxiosMutation({
  serviceCall: TaxRatesService.delete,
  invalidates: () => [taxRatesBaseKey],
})

export const useRestoreTaxRateMutation = makeAxiosMutation({
  serviceCall: TaxRatesService.restore,
  invalidates: () => [taxRatesBaseKey],
})
